import { styled } from "@linaria/react";
import React from "react";
import ButtonIconV2 from "@ui/ButtonIconV2";
import { PencilLine } from "@ui/IconV2/react";
import t from "../../../../i18n";

interface P {
  className?: string;
  openEditModal: (e: React.MouseEvent) => void;
}

const ActionIcons = styled.div`
  display: flex;
  align-items: center;
`;

const Actions = ({ className, openEditModal }: P) => (
  <ActionIcons className={className} data-cy="setup-action-icons">
    <ButtonIconV2 title={t("projects.actions.edit")} data-cy="edit-setup" onClick={openEditModal}>
      <PencilLine size="m" />
    </ButtonIconV2>
  </ActionIcons>
);
export default React.memo(Actions);
